import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { MemberApi } from "../api/MemberApi";
import TanitaMC780Report from "./TanitaMC780Report";
import TanitaMC980Report from "./TanitaMC980Report";

export default function TanitaSection({memberID=0, autoLoad = true, initialData = null }) {
    const [loading, setLoading] = useState(false);
    const [tanitaData, setTanitaData] = useState(initialData);

    // var user = getLocalStorageUser();
    // user = JSON.parse(user);
    const currentMemberID = memberID; // user ? user.id : 0; // useSelector(memberID);


    useEffect(
        () => {
            if (autoLoad) {
                setLoading(true);
                loadLastHealthData();
            }
        }
        , []);

    const loadLastHealthData = async () => {
        console.debug("loadLastHealthData: clicked");

        try {
            const result = await MemberApi.lastMemberHealthData(currentMemberID);
            console.debug("result: ", result);
            setTanitaData(result);    
        } catch (error) {
        } finally {
            setLoading(false);
        }
        
        // setLoading(false);
    }

    // const healthData = tanitaData.health_data;

    if (loading) {
        return <Typography variant="h4">
            載入中 ...
        </Typography>
    }

    if (tanitaData === null) {
        return <Typography variant="h5" sx={{my:4}}>
            未有相關紀錄，請前往測量站，進行健康評估。
        </Typography>
    }

    let healthData = tanitaData.health_data;

    
    if (healthData.model == "MC-780") {
        return <TanitaMC780Report healthData={healthData} />;
    } else if (healthData.model == "MC-980") {
        return <TanitaMC980Report healthData={healthData} />;
    } else {
        return (
          <Typography variant="h5" sx={{ my: 4 }}>
            無法顯示該型號的報告
          </Typography>
        );
    }

}
